import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { AgentModelsView, ModelInfo } from "@/types";

// #224R: der dynamische Modell-Katalog (was die Brains via SDK supportedModels()
// melden). Quelle für den Admin-Fix-Dropdown + die allowedModels-Whitelist in der
// ModelPolicySection. Leer bis ein Brain gebootet hat → der Master liefert dann
// den "default"-Fallback.
export function useSupportedModels(): UseQueryResult<ModelInfo[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.list("models"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<ModelInfo[]>("/models");
    },
    enabled: !!session,
  });
}

// #P001 (UC-2): die für den OWNER wählbaren Modelle EINES Agenten samt Ziel-Anzeige
// (GET /agents/:id/models, owner+admin). Ohne gebundenen Agenten wird nicht geladen —
// die Frage „welche Modelle?" hat ohne Agent keine Antwort.
export function useAgentModels(agentId?: string): UseQueryResult<AgentModelsView> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.subResource("agents", agentId ?? "-", "models"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<AgentModelsView>(`/agents/${agentId}/models`);
    },
    enabled: !!session && !!agentId,
  });
}
